<template>
  <details class="CollapsibleBar">
    <summary class="toggleBar">
      <span class="summaryText">{{ summaryText }}</span>
      <span class="icon" v-html="caretSvg" />
    </summary>
    <div class="menu">
      <slot />
    </div>
  </details>
</template>

<script>
import strings from '../strings.json'
import caretSvg from '~/assets/ui/breadcrumb-caret.svg?raw'

export default {
  inject: [ 'locale' ],
  computed: {
    summaryText() {
      return strings[this.locale].inThisProductGuide
    },
  },
  data() {
    return { caretSvg }
  },
}
</script>

<style scoped>

.CollapsibleBar {
  background-color: var(--bg-color-white);
  border-bottom: thin solid var(--hairline-color);
}

.toggleBar {
  padding: var(--spacing-5) var(--spacing-8);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summaryText {
  font-weight: 500;
  font-size: var(--font-size-1);
  color: var(--text-color-black);
}

.icon {
  transition: transform 0.15s;
}

.menu {
  padding: var(--spacing-5) var(--spacing-8);
}

.CollapsibleBar[open] .icon {
  transform: rotate(90deg);
}
</style>
